import MuiDrawer from '@material-ui/core/Drawer';
import { bodySmall, header1 } from '@monorepo/shared/styles/text';
import styled from 'styled-components';

export const Drawer = styled(MuiDrawer)`
  flex-shrink: 0;

  & .MuiDrawer-paper {
    width: ${({ theme }) => theme.sizes.subnavWidth};
    box-shadow: 0 4px 13px ${({ theme }) => theme.colors.blue24};
  }

  & .MuiDrawer-paperAnchorLeft {
    left: ${({ theme }) => theme.sizes.navbarWidth};
    z-index: ${({ theme }) => theme.constants.subnavZIndex};
  }
`;

export const DrawerHeader = styled.div`
  ${header1}
  padding: 21px;
  overflow-wrap: anywhere;
  background-color: ${({ theme }) => theme.colors.blue04};
`;

export const TabContents = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 13px;
  margin: 0 8px;
  color: ${({ theme }) => theme.colors.gray333};
  text-align: left;

  .subtext {
    ${bodySmall}
    margin-top: 4px;
    color: ${({ theme }) => theme.colors.gray666};
  }

  &:hover {
    font-weight: 700;
  }

  &.selected {
    font-weight: 700;
    color: ${({ theme }) => theme.colors.gray333};
    background-color: ${({ theme }) => theme.colors.green12};
    border-radius: 4px;
  }
`;

export const TabIcon = styled.div`
  display: flex;
  align-items: center;

  & span {
    width: 0.9rem;
  }

  & svg {
    width: 0.9rem;
    color: ${({ theme }) => theme.colors.gray333};
    fill: ${({ theme }) => theme.colors.gray333};
  }
`;

export const SectionDivider = styled.div`
  margin: 0 21px;
  border: none;
  border-top: 1px solid ${({ theme }) => theme.colors.grayddd};
`;

export const SectionTitle = styled.div`
  ${bodySmall}
  padding: 16px 21px 0;
  color: ${({ theme }) => theme.colors.gray666};
`;
